;(function() {

	var $window = $(window);
	var $header = $('header');
	var $menu = $('.mobile.menu');

	function open() { $menu.addClass('open').removeClass('close'); }
	function close() { $menu.addClass('close').removeClass('open'); }

	$menu.find('.filtro.todos').parent().addClass('remove');
	$window.click(close);

	$menu.find('.filter').click(function(event){
		event.stopPropagation();
		var closeMenu = $menu.hasClass('close');
		if(closeMenu){
			open();
		} else {
			close();
		}
	});
	$menu.find('.filtro').click(function(){

		var $text = $(this).html();
		var $buttonClass = $(this).attr('class');

		$menu.find('.filter button .place').remove();

		close();

		$menu.find('.filter button').prepend(
			`<span class="place ${$buttonClass}">${$text}</span>`
		);
		$menu.find('.filter .place').addClass($buttonClass);

		if($menu.find('.filter button .place').hasClass('tema')){
			$menu.css('height', '45px');
		} else {
			$menu.css('height', '30px');
		}
		
		$menu.find('.filtro').parent().removeClass('remove');
		$(this).parent().addClass('remove');
	});

})();








